import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Box,
} from '@mui/material';
import Tag from './Tag';
import React, { useEffect } from 'react';
import { globalService } from '../../Layout/UIContainer/Global/GlobalService';
import { CommonTagProps } from './TagProps';
import CustomButton from '../../../Common/Components/Controls/InputControls';
import { Cancel, Save } from '@mui/icons-material';

const CommonTag = (props: CommonTagProps) => {
  const [selected, setSelected] = React.useState<string[]>([]);

  useEffect(() => {
    loadSelectedTags(props.objectId);
  }, []);

  const loadSelectedTags = async (objectId: string) => {
    await globalService
      .getTagDetailsByObjectId(objectId)
      .then((selectedTags) => {
        setSelected(selectedTags.Items.map((x) => x.TagName));
      });
  };
  return (
    <Dialog
      disableEscapeKeyDown
      open={true}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, p: 3, pb: 2 }}>
        {props.objectType} Tags
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ mt: 1 }}>
          <Tag
            initialOptions={props.options}
            setSelected={setSelected}
            initialSelected={selected}
          />
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2, pt: 1.5 }}>
        <CustomButton
          startIcon={<Cancel />}
          onClick={() => props.setShowTags(false)}
          label="Cancel"
          color="inherit"
        />
        <CustomButton
          startIcon={<Save />}
          onClick={() => {
            props.saveTags(selected);
          }}
          label="Save"
        />
      </DialogActions>
    </Dialog>
  );
};

export default CommonTag;
